export default __webpack_public_path__ + "static/media/icon_direction.677896d6.svg";